import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * VersionBadge
 *
 * Pequeño badge discreto que muestra la versión actual del backend.
 * Se obtiene del endpoint `/api/version` (servido desde `/app/VERSION`).
 *
 * Útil para:
 * - Que el usuario reporte bugs con la versión exacta
 * - Confirmar visualmente que un deploy llegó
 * - Audit trail en clases/sesiones de soporte
 *
 * Pensado para footer, modal "Acerca de" o esquina del dashboard.
 */
export default function VersionBadge({ className = "", prefix = "v" }) {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/version`, { withCredentials: false })
      .then((r) => {
        if (!cancelled) setVersion(r.data?.version || null);
      })
      .catch((e) => {
        console.warn("VersionBadge: no se pudo leer /api/version", e);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!version) return null;

  return (
    <span
      data-testid="qhub-version-badge"
      className={`text-[11px] text-gray-400 font-mono ${className}`}
      title={`QHUB.BUDDY ${prefix}${version}`}
    >
      {prefix}
      {version}
    </span>
  );
}
